/**
 * Final paint policy for BaseTemplate hero flags.
 *
 * Worker / cta-flags / purchase-eval already merged into `merged`.
 * This is the last step before the hero button: pass those flags through
 * unless an emergency kill or editorial no-CTA lock is on.
 *
 * Do not hard-zero show* here — admin + CTA por región own conversion.
 */

import type { CtaFlagsLike } from "@/lib/visitorPurchaseEvalStorage";

export type BaseTemplateHeroPaintInput = CtaFlagsLike & {
  editorialNoCta?: boolean;
  neverHeroCta?: boolean;
  ctaUrl?: string;
  ctaLabel?: string;
};

export type BaseTemplateHeroPaintResult = {
  hideCta: boolean;
  showCheckout: boolean;
  showCommunity: boolean;
  showBirthday: boolean;
  showWishlist: boolean;
  showBestFriends: boolean;
  ctaUrl: string | undefined;
  ctaLabel: string | undefined;
};

export function resolveBaseTemplateHeroPaint(
  input: BaseTemplateHeroPaintInput,
): BaseTemplateHeroPaintResult {
  if (input.neverHeroCta || input.editorialNoCta) {
    return {
      hideCta: true,
      showCheckout: false,
      showCommunity: false,
      showBirthday: false,
      showWishlist: false,
      showBestFriends: false,
      ctaUrl: undefined,
      ctaLabel: undefined,
    };
  }

  return {
    hideCta: input.hideCta ?? false,
    showCheckout: input.showCheckout ?? false,
    showCommunity: input.showCommunity ?? false,
    showBirthday: input.showBirthday ?? false,
    showWishlist: input.showWishlist ?? false,
    showBestFriends: input.showBestFriends ?? false,
    ctaUrl: input.ctaUrl,
    ctaLabel: input.ctaLabel,
  };
}
